import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import * as moment from 'moment';
import 'moment/locale/fr';

@Component({
  selector: 'app-rdv',
  templateUrl: './rdv.component.html',
  styleUrls: ['./rdv.component.scss'],
})
export class RdvComponent implements OnInit {
  events: any;
  year = moment().format('YYYY');
  dates: any;
  constructor(public api: ApiService) {}

  ngOnInit(): void {
    this.setYear(0);
  }

  refresh() {
    this.api
      .post('eventAdmin=getEvents&withCover', this.dates)
      .then((res: any) => {
        this.events = res.filter((item:any) => {
          return (item.users_brg.length > 0 || item.users_out.length > 0);
        });
      });
  }

  setYear(i) {
    this.year = parseInt(this.year) + i;
    this.dates = {
      start: moment(this.year + '-01-01').toDate(),
      end: moment(this.year + '-12-31').toDate(),
    };
    this.refresh();
  }
}
